import React from 'react';
import PopupFrameV2 from '../../modules/popup/PopupFrameV2';
import http from '../../modules/api';
import * as StringUtil from '../../modules/utils/StringUtil';

export class AiRpInfoPopup extends React.Component {
    constructor(props) {
		super(props);
        this.state = {
            ai_algorithm_type_code_name : "",
            ai_algorithm_type_sumnail_img_url : "",
            is_AiRpInfoPopup_show : true,
        }
    }

    componentDidMount() {
        this.loadAiAlgorithmTypeCode();
    }

    loadAiAlgorithmTypeCode() {
        const {ai_algorithm_type_code} = this.props.ai_algorithm_type_code ? this.props : this.props.match.params;
        
        http.get("/rest/shop/aiAlgorithmTypeCd?code_cd="+ai_algorithm_type_code)
        .then(res => {
            const code_name = res.data.code_name;
            const sumnail_img_url = res.data.sumnail_img_url;
            this.setState({
                ai_algorithm_type_code_name : code_name,
                ai_algorithm_type_sumnail_img_url : sumnail_img_url
            });
        })
        .catch(error => {
        });
    }

    onClickMintBtn() {
        const {ai_algorithm_code_cd} = this.props.ai_algorithm_type_code ? this.props : this.props.match.params;
        const {ai_algorithm_type_code} = this.props.ai_algorithm_type_code ? this.props : this.props.match.params;
        window.location.href = `/shop/ai/rp/eventSetting?ai_algorithm_cd=${ai_algorithm_code_cd}&ai_algorithm_type_code=${ai_algorithm_type_code}`;
    }

    render() {
        const {
            ai_algorithm_type_code_name,
            ai_algorithm_type_sumnail_img_url
        } = this.state;
        return (
            this.state.is_AiRpInfoPopup_show &&
            <PopupFrameV2
            maxWidth={"600px"}
            padding={"40px"}
            onClose={() => this.props.onClose ? this.props.onClose() : this.setState({is_AiRpInfoPopup_show : false})}
            >
                <div className="ai-recommend-popup-container style_guide_v2">
                    <div className="ai-recommend-popup-title">{`AI 로보MD ${ai_algorithm_type_code_name} 추천시작 안내`}</div>
                    <div style={{"background-image": `url('${ai_algorithm_type_sumnail_img_url}')`}} className="ai-recommend-popup-avatar"/>
                    <div className="ai-recommend-popup-description"
                      dangerouslySetInnerHTML = {{__html : `
                        AI로보MD ${ai_algorithm_type_code_name}에게 2달간 데이터를 분석합니다.<br/>
                        인공지능학습과 설치까지 최대 2주가 소요될 예정이에요<br/>
                        설치 후 2주간 상품추천을 무료로 받으시고 이후<br/>
                        사용 페이지뷰에 따라서 별도 요금이 부과됩니다.<br/>
                        ${ai_algorithm_type_code_name}의 상품추천을 받으시려면 설치를 원하는 위치와 디자인유형을 선택해주세요
                        `}}
                    >
                    </div>
                    <div className="ai-recommend-popup-buttons">
                        <button className="ai-recommend-popup-button hover_white" onClick={() => this.props.onClickWhiteBtn()}>추천상품 가격 상담받기</button>
                        <button className="ai-recommend-popup-button hover_mint" onClick={() => this.props.onClickMintBtn ? this.props.onClickMintBtn() : this.onClickMintBtn()}>위치와 디자인 선택하기</button>
                    </div>
                </div>
            </PopupFrameV2>
        )
    }
  }